import {setUrl} from './request';

const updateUrlParamsAndReload = (key: string, value: number | string) => {
    const url = new URL(window.location.href);
    url.searchParams.set(key, String(value));
    setUrl(url.href);
};

export default updateUrlParamsAndReload;
